module.exports = {
    ALL: [{
        name: "[MOLPoints] Prepaid Card",
        channelId: 3,
        logo: "mol_points.png",
        amount:{'': ''}
    }, {
        name: "[MOLPoints] E-Wallet",
        channelId: 1,
        logo: "mol_points.png",
        amount: {
            USD: [5, 10, 20, 50, 100],
            IDR: [2200, 4500, 9000, 10000, 13500, 18000, 20000, 22500, 50000, 100000, 200000, 500000],
            INR: [50, 100, 250, 1000, 2000, 2500, 3000],
            MYR: [3, 5, 7, 10, 20, 30, 40, 50, 100, 200, 300, 500],
            SGD: [5, 10, 20, 30, 50, 60, 100],
            THB: [20, 60, 90, 100, 150, 200, 300, 500, 1000, 2000, 3500, 5000],
            TWD: [50, 100, 300, 500, 1000, 2000],
            VND: [10000, 20000, 30000, 50000, 100000, 200000, 300000, 500000, 1000000, 2000000, 5000000]
        }
    }, {
        name: "[Rixty] E-Wallet / Prepaid Card",
        channelId: 2,
        logo: "rixty.png",
        amount: {
            USD: [5, 10, 20, 50, 100]
        }
    }, {
        name: "[EasyTopUp] Prepaid Card",
        channelId: 6,
        logo: "easy_top_up.png",
        amount:{'': ''}
    }, {
        name: "[NganLoung] Prepaid Card",
        channelId: 7,
        logo: "nganluong.png",
        amount:{'': ''}
    }, {
        name: "[Easy2Pay] Carrier Billing",
        channelId: 8,
        logo: "easy2pay.png",
        amount:{'': ''}
    }, {
        name: "[GameSultan] E-Wallet",
        channelId: 9,
        logo: "gamesultan.png",
        amount: {
            USD: [5, 10, 20, 50, 100],
            TRY: [15, 20, 50, 100, 150, 200, 250],
            EUR: [5, 10, 20, 50, 80]
        }
    }, {
        name: "[MOLPay Credit Card] Credit Card",
        channelId: 10,
        logo: "mol.png",
        amount: {
            USD: [10, 20, 50, 100],
            IDR: [200000, 500000],
            INR: [1000, 2000, 2500, 3000],
            MYR: [40, 50, 100, 200, 300, 500],
            SGD: [20, 30, 50, 60, 100],
            THB: [300, 500, 1000, 2000, 3500],
            TWD: [300, 500, 1000, 2000],
            VND: [200000, 300000, 500000, 1000000, 2000000]
        }
    }, {
        name: "[PayPal] E-Wallet",
        channelId: 11,
        logo: "paypal.png",
        amount: {
            USD: [5, 10, 20, 50, 100],
            IDR: [2200, 4500, 9000, 10000, 13500, 18000, 20000, 22500, 50000, 100000, 200000, 500000],
            INR: [50, 100, 250, 1000, 2000, 2500, 3000],
            MYR: [3, 5, 7, 10, 20, 30, 40, 50, 100, 200, 300, 500],
            SGD: [5, 10, 20, 30, 50, 60, 100],
            THB: [20, 60, 90, 100, 150, 200, 300, 500, 1000, 2000, 3500, 5000],
            TWD: [50, 100, 300, 500, 1000, 2000],
            VND: [10000, 20000, 30000, 50000, 100000, 200000, 300000, 500000, 1000000, 2000000, 5000000]
        }
    }]
};


// WEBPACK FOOTER //
// ./src/config/pay/mol.js